import { format as formatDate, isDate } from 'date-fns'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { ru as ruDateLocale, enUS as enDateLocale } from 'date-fns/locale'
const ru = require('./locales/ru.json')
const en = require('./locales/en.json')

const resources = {
  ru: {
    translation: ru,
  },
  en: {
    translation: en,
  },
}

const savedLanguage = localStorage.getItem('language') || 'ru'

const dateFnsLocales: Record<string, any> = {
  ru: ruDateLocale,
  en: enDateLocale,
}

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage,
  fallbackLng: 'ru',
  interpolation: {
    escapeValue: false,
    format: (value, format, lng) => {
      if (isDate(value) && lng && format) {
        const locale = dateFnsLocales[lng]
        return formatDate(value, format, { locale })
      }
      return value
    },
  },
})

export default i18n
